import { createContext, useContext } from 'react';

type CheckBoxListContextType = {
  onClose: (value: string[]) => void;
};

const CheckBoxListContext = createContext<CheckBoxListContextType | undefined>(
  undefined,
);

type CheckBoxListProviderProps = {
  onClose: (value: string[]) => void;
  children: React.ReactNode;
};

export function CheckBoxListProvider({
  onClose,
  children,
}: CheckBoxListProviderProps) {
  return (
    <CheckBoxListContext.Provider value={{ onClose }}>
      {children}
    </CheckBoxListContext.Provider>
  );
}

export function useCheckBoxList() {
  const context = useContext(CheckBoxListContext);
  if (context === undefined) {
    throw new Error(
      'useCheckBoxList must be used within a CheckBoxListProvider',
    );
  }
  return context;
}
